import React, { Component } from "react";
import { ToastContainer } from "react-toastify";
import toast from "../helpers/toast";
import Httpconfig from "../helpers/Httpconfig";
import Constant from "../../constants";
import { MDBDataTable } from "mdbreact";
import { Link } from "react-router-dom";
import PatientHeader from "../patient/Patientheader";
import PatientSideMenu from "../patient/Patientsidemenu";
import ReactExport from "react-data-export";

import * as SecureLS from "secure-ls";
var ls = new SecureLS({
  encodingType: "aes",
  encryptionSecret: "medleymed",
});
const moment = require("moment");


export default class ViewClinics extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page_data: "",
      datatable: {
        columns: [
            {
                label: "Sno",
                field: "Sno",
                sort: "asc",
                width: 150,
              },
            {
                label: "Date",
                field: "date",
                sort: "asc",
                width: 150,
            },
          {
            label: "Medicine Name",
            field: "medicine_name",
            sort: "asc",
            width: 150,
          },
          {
            label: "Patient Id",
            field: "patient_id",
            sort: "asc",
            width: 150,
          },         
          {
            label: "Time",
            field: "time",
            sort: "asc",
            width: 150,
          },
          {
            label: "Status",
            field: "status",
            sort: "asc",
            width: 150,
          }
        ],
        rows: [],
      },
    };
   
  }

  // To get detais after first render
  componentDidMount = () => {
    var retrievedObject = ls.get("userObjEnc");
    var patient_id = ls.get("SelectedPatientIdEnc");


    this.fetchpagesdata();
  
  };

  // When value changes of the fields
  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  fetchpagesdata() {
    Httpconfig.httptokenget(Constant.siteurl + "api/Remindersetting/getConfirmation")
      .then((response) => {
        this.setState({
          page_data: response.data.data,
        });
        let assignvalues = [];
        this.items = response.data.data.map((item, key) =>          
          assignvalues.push({
            Sno: key + 1,
            medicine_name: item.medicine_name,
            patient_id:item.patient_tbl.name,
            //doctor_id:item.doctor_id,
            // numberoftimes:item.numberoftimes,
            date:   moment(item.date).format("DD-MMM-YYYY hh:mm a"),   
            time:item.time,
            status: (item.status == "1") ? "Yes" : "No",       
            
          })
        );
        let reminderSetting = Object.assign({}, this.state);
        reminderSetting.datatable.rows = assignvalues;
        this.state.finalordersarray=assignvalues;
        this.forceUpdate();
        this.setState(reminderSetting);
      })
      .catch((error) => {
        console.log(error);
      });
  }


  render() {
    const { datatable } = this.state;
    return (
      <main id="main">
      <PatientHeader onSelectLanguage={this.handleLanguage} />
      <section id="main_dashboard">
        <div className="container" id="main_front">
          <div className="row">
          <div class="col-lg-3 col-md-12">
                    <PatientSideMenu />
                  </div>
                  <div class="col-lg-9 col-md-12">
              <section id="CMS_tab">
                <div className="CMS_content">
                  <div className="container">
                    <div className="row">
                      <div className="tab-header">
                        <h3> View Reminder Confirmation Info </h3>
                      </div>
                      <div id="reg_form">
                        <form>
                          <div className="row">
                          
                          </div>
                        </form>
                        {datatable.rows.length === 0 ? (
                          <p>No Records Found</p>
                        ) : (
                          <MDBDataTable
                            striped
                            responsive
                            bordered
                            small
                            data={datatable}
                          />
                        )}
                        <div className="row">
                          <div className="col-md-12">
                            <div
                              className="update_btn"
                              style={{ textAlign: "right" }}
                            ></div>
                          </div>
                        </div>
                        <ToastContainer />
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </section>
      </main>
    );
  }
}
